import React, {useState, useRef} from 'react';
import UserTable from '@/page/customer/InheritPage/UserTable';
import {transfer} from '@/api/customer';
import {transferRoom} from '@/api/room';
import {message} from 'antd';
import StepModal from '@/page/customer/InheritPage/StepModal';
import {useEditAuthService} from '@/page/admin/adminService';

export default function QuitPage() {
    const editable = useEditAuthService(['global:customer_offjob_inherit:w']);
    const modalRef = useRef();
    const [user, setUser] = useState({});

    function open(record) {
        setUser(record);
        modalRef.current.open();
    }

    function getResult(toUserId, selectedRowKeys, isCustomer = true) {
        let params = isCustomer
            ? {
                  fromUserId: user.extId,
                  toUserId: toUserId,
                  extUserIds: selectedRowKeys,
                  transferType: '2',
              }
            : {
                  fromUserId: user.extId,
                  toUserId: toUserId,
                  roomIds: selectedRowKeys,
              };
        if (isCustomer) {
            transfer(params).then(res => {
                if (res.data.errcode === 0) {
                    message.success('移交成功');
                } else {
                    message.error('移交失败:' + res.data.errcode + '_' + res.data.errmsg);
                }
            });
        } else {
            transferRoom(params).then(res => {
                if (res.data.failChats.length === 0) {
                    message.success('移交成功');
                } else {
                    res.data.failChats.forEach(item => {
                        message.error(
                            '客户群ID:' +
                                item.roomId +
                                '移交失败:' +
                                item.errmsg +
                                ',具体错误查询 https://open.work.weixin.qq.com/devtool/query?e=' +
                                item.errcode
                        );
                    });
                }
            });
        }
    }

    return (
        <div style={{overflowY: 'auto'}}>
            <UserTable onJob="false" openModal={open} editable={editable}/>
            <StepModal ref={modalRef} user={user} getResult={getResult} transferType="2" />
        </div>
    );
}
